"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconGeneralMeeting = function IconGeneralMeeting(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M26.463 5.319a1 1 0 1 0-1.414 1.414l7.07 7.07a1 1 0 0 0 1.415-1.413zm-2.829-1.415a3 3 0 0 1 4.243 0l7.071 7.071a3 3 0 0 1-3.41 4.832l-2.246 2.245 13.433 13.433a3.006 3.006 0 0 1 0 4.243 3.006 3.006 0 0 1-4.243 0L25.05 22.295l-2.238 2.238a3.001 3.001 0 0 1-4.828 3.415l-7.072-7.071a3 3 0 1 1 4.243-4.243l6.364 6.364 2.117-2.117-.002-.002 4.243-4.243.002.002 2.124-2.124-5.657-5.656-7.078 7.07-1.414-1.416 7.197-7.188a3 3 0 0 1 .584-3.42m2.83 16.977 1.414-1.415L41.31 32.9a1.006 1.006 0 0 1 0 1.414 1.006 1.006 0 0 1-1.414 0zm-6.36 3.531h-.001l.737.738a1 1 0 0 1-1.443 1.384l-7.071-7.071a1 1 0 0 1 1.414-1.415zM11 35a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m-1.5 4a.5.5 0 0 0 0 1h18a.5.5 0 0 0 0-1zm-2.5.5A2.5 2.5 0 0 1 9.5 37h18a2.5 2.5 0 0 1 0 5h-18A2.5 2.5 0 0 1 7 39.5m17.347-27.814-4.25 4.24.706.708 4.25-4.24zm-18.025 17 .707-.707 1.633 1.634-.707.707zM12 27h-1v2h1zm-7 6h2v1H5z",
    clipRule: "evenodd"
  })));
};

export { IconGeneralMeeting, IconGeneralMeeting as default };
